import * as React from "react";

import type { DesignaliProps } from "../../types";

export const ArtificialIntelligence06 = React.forwardRef<
  SVGSVGElement,
  DesignaliProps
>(({ ...props }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={forwardedRef}
    >
      <path d="M21.01,14.1c.52-.14.78-.21.89-.35.1-.13.1-.35.1-.78v-1.93c0-.43,0-.65-.1-.78-.1-.13-.36-.2-.89-.35-1.95-.53-3.17-2.57-2.67-4.5.14-.53.21-.8.14-.96-.07-.16-.26-.26-.64-.48l-1.72-.98c-.37-.21-.56-.32-.73-.29-.17.02-.36.21-.73.59-1.46,1.46-3.87,1.46-5.33,0-.38-.38-.57-.56-.73-.59-.17-.02-.35.08-.73.29l-1.72.98c-.38.22-.57.32-.64.48-.07.16,0,.42.14.96.5,1.94-.72,3.98-2.67,4.5-.52.14-.78.21-.89.35-.1.13-.1.35-.1.78v1.93c0,.43,0,.65.1.78.1.13.36.2.89.35,1.95.53,3.17,2.57,2.67,4.5-.14.53-.21.8-.14.96.07.16.26.26.64.48l1.72.98c.37.21.56.32.73.29.17-.02.36-.21.73-.59,1.46-1.46,3.88-1.46,5.34,0,.38.38.57.56.73.59.17.02.35-.08.73-.29l1.72-.98c.38-.22.57-.32.64-.48.07-.16,0-.42-.14-.96-.5-1.94.72-3.98,2.67-4.5Z" />

      <path d="M7.5,14.5l1.84-5.53c.09-.28.36-.47.66-.47s.56.19.66.47l1.84,5.53M15.5,8.5v6M8.5,12.5h3" />
    </svg>
  );
});

export default ArtificialIntelligence06;
